var EsriLeaflet = { //jshint ignore:line
  VERSION: '1.0.0-rc.2',
  Layers: {},
  Services: {},
  Controls: {},
  Tasks: {},
  Util: {},
  Support: {
    CORS: !!(window.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest()),
    pointerEvents: document.documentElement.style.pointerEvents === ''
  }
};

if(typeof window !== 'undefined' && window.L){
  window.L.esri = EsriLeaflet;
};
define("lib/esri-leaflet/src/EsriLeaflet.js", function(){});

